export default __webpack_public_path__ + "static/media/image24.45de94c8.png";